module.exports = __webpack_public_path__ + "public/media/step_5_draw_party_confetti.low.ab60624b.mp4";